import PropTypes from 'prop-types';
import React, { useContext, useEffect, useMemo } from 'react';

import { useFlow } from '@ezbobdev/ui-commons';
import { MainContext } from '@ezbobdev/ui-framework';

import MaterialBackdrop from '../MaterialBackdrop/MaterialBackdrop';

const Flow = (props) => {
  const { className, children, popupLoaderRender, disablePopupLoader, onLoadingState } = props;
  const { actions } = useContext(MainContext);
  const { wrapperClasses } = useFlow(props);
  const isLoadingState = actions.view.getView('showPopupLoader');
  const showPopupLoader = Boolean(isLoadingState && !disablePopupLoader);
  const popupLoaderText = actions.view.getView('popupLoaderText');

  useEffect(() => {
    if (typeof onLoadingState === 'function') {
      onLoadingState(isLoadingState);
    }
  }, [isLoadingState]);

  return useMemo(
    () => (
      <div className={wrapperClasses}>
        {children}

        {showPopupLoader ? popupLoaderRender || <MaterialBackdrop open={true} loadingText={popupLoaderText} /> : null}
      </div>
    ),
    [
      showPopupLoader,
      children,
      className,
      isLoadingState,
      wrapperClasses,
      popupLoaderRender,
      disablePopupLoader,
      onLoadingState,
    ],
  );
};

Flow.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  popupLoaderRender: PropTypes.node,
  disablePopupLoader: PropTypes.bool,
  onLoadingState: PropTypes.func,
};

export default React.memo(Flow);
